import React from "react";
import { StoryblokVideoHero } from "../../../interfaces/Storyblok/StoryblokVideoHero.interface";
import YoutubeVideo from "../../atoms/YoutubeVideo/YoutubeVideo.atom";
import Crumb from "../../atoms/Crumb/Crumb.atom";

const VideoHero: React.FC<StoryblokVideoHero> = ({ title, description, crumb, youtube_video_id }) => {
  return (
    <section className="relative flex min-h-[520px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      {youtube_video_id && (
        <div className="absolute inset-0 z-0">
          <YoutubeVideo video_id={youtube_video_id} autoplay loop isBackground />
        </div>
      )}

      <div className="absolute inset-0 z-10 bg-Black/50" aria-hidden="true" />

      <div className="container relative z-20 mx-auto flex flex-col items-center px-6 py-16 text-center md:py-24">
        {crumb && <Crumb label={crumb} variant="light" className="mb-6" />}
        {title && (
          <h1 className="max-w-4xl text-4xl font-extrabold leading-tight text-White md:text-5xl">{title}</h1>
        )}
        {description && (
          <p className="mt-6 max-w-3xl text-xl font-medium leading-relaxed text-White">{description}</p>
        )}
      </div>
    </section>
  );
};

export default VideoHero;
